import { FactoryIcon, GemIcon, MountainIcon, PickaxeIcon, SearchIcon, ShieldCheckIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Module = {
  number: string;
  title: string;
  summary: string;
  icon: LucideIcon;
};

export const modules: Module[] = [
  {
    number: '1',
    title: "Fondamenti dell'Industria Mineraria e delle Risorse Minerali",
    summary: 'Che cosa sono le risorse minerali, la catena dalla roccia al prodotto, storia delle miniere, tenore, metalli di base e minerali nella vita quotidiana.',
    icon: PickaxeIcon,
  },
  {
    number: '2',
    title: 'Geologia, Minerali e Giacimenti Minerari',
    summary: 'Che cos’è un minerale, proprietà e riconoscimento, ciclo delle rocce, giacimenti magmatici, idrotermali e sedimentari, lettura di una roccia mineralizzata.',
    icon: GemIcon,
  },
  {
    number: '3',
    title: 'Esplorazione Mineraria e Valutazione delle Risorse',
    summary: 'Dall’area vasta al bersaglio, geochimica e geofisica, sondaggi e carote, stima delle risorse, studi di fattibilità e rapporto con le comunità.',
    icon: SearchIcon,
  },
  {
    number: '4',
    title: 'Metodi di Estrazione a Cielo Aperto e in Sotterraneo',
    summary: 'Come si sceglie il metodo, miniere a gradoni e cave, perforazione e carico, ciclo di avanzamento in galleria, ventilazione, drenaggio e sicurezza.',
    icon: MountainIcon,
  },
  {
    number: '5',
    title: 'Trattamento dei Minerali e Recupero del Valore',
    summary: 'Frantumazione e macinazione, separazione per proprietà, flottazione, lisciviazione, dal minerale di ferro all’acciaio, controllo e impianto digitale.',
    icon: FactoryIcon,
  },
  {
    number: '6',
    title: 'Sicurezza, Ambiente e Chiusura delle Miniere',
    summary: 'Gerarchia dei controlli, rischi in miniera, gestione delle acque, polvere e rumore, comunità, chiusura e recupero, patrimonio minerario italiano.',
    icon: ShieldCheckIcon,
  },
];
